exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms {\r\n  padding-left:0;\r\n  margin-left:-60px;\r\n}\r\n\r\n@media(max-width:768px){\r\n  .terms {\r\n    padding-left:0;\r\n    margin-left:12px!important;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/privacy-policy/privacy-policy.component.css
// module id = ../../../../../src/app/privacy-policy/privacy-policy.component.css
// module chunks = 2